import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleMinus } from '@fortawesome/pro-solid-svg-icons/faCircleMinus';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';

import type { AlertBannerStatus } from './alert-banner-types';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const STATUS_ICON_MAP: Record<AlertBannerStatus, IconDefinition> = {
  alert: faCircleExclamation,
  success: faCircleCheck,
  warning: faTriangleExclamation,
  inform: faCircleInfo,
  upgrade: faBolt,
  neutral: faCircleMinus,
};
